export default {
  es: {
    operation: 'Operación',
    create: 'Crear perfil',
    edit: 'Editar perfil',
    view: 'Ver perfil',
    deleteProfile: '¿Estás seguro de eliminar este perfil?',
    profileCreated: 'Un nuevo perfil ha sido creado',
    profileUpdated: 'Un perfil ha sido actualizado',
    profileDeleted: 'Un perfil ha sido eliminado'
  },
  en: {
    operation: 'Operation',
    create: 'Create profile',
    edit: 'Edit profile',
    view: 'View profile',
    deleteProfile: 'Do you want to delete this profile?',
    profileCreated: 'A new profile have been created',
    profileUpdated: 'A profile have been updated',
    profileDeleted: 'A profile have been deleted'
  }
};
